import { mapSurveyStylingFromApiModel } from 'styling/api/dataMapper/surveyStylingDataMapper';
import { toAppBlockFormat } from 'sharedParts';

import {
  getHeaderItemBlocks,
  getLandingItemBlocks,
  getQuestionItemBlocks,
  getThankYouItemBlocks,
  pickPreviewImage,
} from './filterItemListBySection';
import { toHeaderBlockFormat } from './headerDataMapper';
import toAppThumbnailFormat from './toAppThumbnailFormat';

export const mapSurveyFromJsonApiModel = ({
  data: {
    attributes: {
      access_allow_ip,
      access_block_ip,
      access_default,
      blocked_message,
      created_at,
      cut_off_date,
      date_launched,
      default_styles_snapshot,
      end_enabled,
      header_end_enabled,
      header_landing_enabled,
      header_questions_enabled,
      header_uuid,
      is_back_button_enabled,
      is_question_numbering_enabled,
      is_full_width,
      landing_enabled,
      local_styles,
      max_responses_partial,
      max_responses,
      name,
      psl_questions_count,
      re_captcha_enabled,
      redirect_url,
      repeat_duration,
      repeat_message,
      report_settings,
      send_without_updates,
      slug,
      status,
      timezone,
      update_emails,
      update_frequency,
      updated_at,
      uuid,
    },
    id,
  },
  included,
}) => ({
  id,
  name,
  slug,
  status,
  uuid,
  headers: getHeaderItemBlocks(included).map(toHeaderBlockFormat),
  headerEndEnabled: header_end_enabled,
  headerLandingEnabled: header_landing_enabled,
  headerQuestionsEnabled: header_questions_enabled,
  headerUuid: header_uuid,
  landing: getLandingItemBlocks(included).map(toAppBlockFormat),
  questions: getQuestionItemBlocks(included).map(toAppBlockFormat),
  end: getThankYouItemBlocks(included).map(toAppBlockFormat),
  previewImage: toAppThumbnailFormat(pickPreviewImage(included)),
  localStyling: mapSurveyStylingFromApiModel(local_styles),
  defaultStylesSnapshot: mapSurveyStylingFromApiModel(default_styles_snapshot),
  dateLaunched: date_launched,
  endEnabled: end_enabled,
  landingEnabled: landing_enabled,
  isFullWidth: is_full_width,
  redirectUrl: redirect_url,
  createdAt: created_at,
  updatedAt: updated_at,
  settings: {
    reportSettings: {
      [update_frequency]: report_settings,
    },
    updateFrequency: update_frequency,
    repeatDuration: repeat_duration,
    updateEmails: update_emails,
    repeatMessage: repeat_message,
    blockedMessage: blocked_message,
    accessDefault: access_default,
    accessBlockIp: access_block_ip,
    accessAllowIp: access_allow_ip,
    reCaptchaEnabled: re_captcha_enabled,
    maxResponses: max_responses,
    maxResponsesPartial: max_responses_partial,
    cutOffDate: {
      dateTime: cut_off_date,
      timezone,
    },
    postLogicQuestionsCount: psl_questions_count,
    sendWithoutUpdates: send_without_updates,
    isBackButtonEnabled: is_back_button_enabled,
    questionNumberingEnabled: is_question_numbering_enabled,
  },
});
